import { render, staticRenderFns } from "./material-analysis-preview.vue?vue&type=template&id=bc1832f0&scoped=true"
import script from "./material-analysis-preview.vue?vue&type=script&setup=true&lang=js"
export * from "./material-analysis-preview.vue?vue&type=script&setup=true&lang=js"
import style0 from "./material-analysis-preview.vue?vue&type=style&index=0&id=bc1832f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1832f0",
  null
  
)

export default component.exports